import React from 'react';
import '../../App.css';
import './Footer.css';

const Footer = () => (
    <footer className="footer">
        <div className="footer-logo-box">
            <div className="footer-about">
                <span className='footer-image'></span>
                {/* <img src="../../../public/images/tpLogo.svg" height="64" width="64" alt="Teleperformace"/> */}
                <h2 className="footer-logo ml-2 mt-1"></h2>
                    {/* <p>When people and technology come together, you get exceptional results. We combine our dedicated global workforce of 4,000+ recruiting resources AND best-of-breed tech — delivering the best talent possible to our global portfolio of clients.</p> */}
            </div>
            <div className="footer-credits">
                <div className="footer-social">
                    <a href="https://www.linkedin.com/company/teleperformance" target="_blank" className="footer-linkedin">
                    <i className="fa fa-linkedin fs-36"></i>
                    </a>

                </div>
                <div className="copyright">© 2026 All rights reserved</div>
            </div>
        </div>
    </footer>
);

export default Footer;